// extracted by mini-css-extract-plugin
export default {"product_name":"product_name__bb6952c4"};